import APP from '../../../main.js'
import Document from './Document.js'
class InvestmentReport extends Document {
  get data_updated_days_ago(){
    let cre = Date.parse(this.data_updated_at)
    let now = Date.now()
    return (now-cre)/1000/60/60/24
  }
  get data_updated_days_ago_string(){
    return this.daysAgoToString(this.data_updated_days_ago)
  }
  get outdated(){
    return this['outdated?']
  }
  get owner(){
    return this.constructor.employeeStore.entitiesById.get(this.owner_id)
  }
  get owner_name(){
    if(this.owner){
      return this.owner.name
    } else {
      return undefined
    }
  }
  get privileges(){
    return []
  }
  get canEdit(){
    return true
  }
  get canDestroy(){
    return true
  }
  get canGrant(){
    return false
  }
}
export default InvestmentReport
